import { getAuth, signInAnonymously } from "@firebase/auth";
import { useEffect } from "react";
import { useCurrentUser } from 'src/ui/CurrentUserLoader';

export function AutoAnonymousLogin() {
  const user = useCurrentUser();

  useEffect(() => {
    if (!user) signInAnonymously(getAuth());
  }, [user]);

  return null;
}
